import { AxiosResponse } from "axios"

import { request } from "../../request"
import { CustomerData, DealershipData } from "./hook"

const valuationConfig = {
  ActionType: "PurchaseAVehicle",
  Vehicle: {},
  Customer: {},
}

export const getBookingRequest = async (
  vehicleDetails: any,
  customerDetails: CustomerData,
  dealerShipDetails: DealershipData
): Promise<AxiosResponse<string>> => {
  const { AppointmentDateTime, VehicleType, DealershipName, DealershipGuid } =
    dealerShipDetails

  const data = {
    ...valuationConfig,
    Vehicle: vehicleDetails,
    Customer: customerDetails,
    AppointmentDateTime: AppointmentDateTime,
    VehicleType: VehicleType,
    DealershipName: DealershipName,
    DealershipGuid: DealershipGuid,
  }

  return request({
    url: "/CreatePurchaseLead",
    method: "post",
    headers: {
      "Access-Control-Request-Methods": "*",
      "Access-Control-Allow-Origin": "*",
    },
    timeout: 120000,
    data,
  })
}
